import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FileText } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

interface ExportNamingFieldsProps {
  role: string;
  company: string;
  applicantName: string;
  onRoleChange: (next: string) => void;
  onCompanyChange: (next: string) => void;
  onApplicantNameChange: (next: string) => void;
}

export const ExportNamingFields = ({
  role,
  company,
  applicantName,
  onRoleChange,
  onCompanyChange,
  onApplicantNameChange,
}: ExportNamingFieldsProps) => {
  const preview = [role, company, "Resume", applicantName].filter(Boolean).join("_") || "Resume";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <FileText className="w-4 h-4" />
          File Name
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-4">
          <div>
            <h4 className="font-heading font-semibold text-sm mb-1">Export File Name</h4>
            <p className="text-xs text-muted-foreground">
              These fields control how your downloaded PDF/DOCX file is named. Fill them in so every export is organized.
            </p>
          </div>

          <div className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="naming-role" className="text-xs">Target Role</Label>
              <Input
                id="naming-role"
                value={role}
                onChange={(e) => onRoleChange(e.target.value)}
                placeholder="e.g., Product Manager"
                className="h-8 text-sm"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="naming-company" className="text-xs">Company</Label>
              <Input
                id="naming-company"
                value={company}
                onChange={(e) => onCompanyChange(e.target.value)}
                placeholder="e.g., Google"
                className="h-8 text-sm"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="naming-name" className="text-xs">Your Name</Label>
              <Input
                id="naming-name"
                value={applicantName}
                onChange={(e) => onApplicantNameChange(e.target.value)}
                placeholder="e.g., Jane Doe"
                className="h-8 text-sm"
              />
            </div>
          </div>

          <div className="pt-2 border-t border-border">
            <p className="text-[11px] text-muted-foreground">
              <span className="font-medium text-foreground">Preview:</span>{" "}
              {preview}.pdf
            </p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
